//
$(document).ready(function(){
$(".product .wrapper-buy-btn .atw-button.atw-button-add").click(function(){
     setTimeout(function() {
    location.href = "https://prairie-patched-hats-alberta.myshopify.com/pages/swym-wishlist";
     },5000);
 });

});
  function sortfilter(elem) {
  console.log('ssff');
    elem.classList.toggle('active-filters');
      $('body').toggleClass('dropdown-active');
}

function mobsortfilter() {
   $('span.mobile-facets__open-label.button-label.medium-hide.large-up-hide').trigger('click');
}

const section = document.getElementById('explore_our_range');

if (section) {
  const container = section.querySelector('#ProductGridContainer');

  if (container) {
    const listItems = Array.from(container.querySelectorAll('li'));

    // Remove any old item-* class
    container.classList.forEach(cls => {
      if (cls.startsWith('item-')) {
        container.classList.remove(cls);
      }
    });

    // Add the new class based on count
    container.classList.add(`item-${listItems.length}`);
  } else {
    console.warn('ProductGridContainer not found inside explore_our_range');
  }
} else {
  console.warn('Section #explore_our_range not found');
}

document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById('explore_our_range');
  if (!section) {
    console.warn('Section #explore_our_range not found.');
    return;
  }

  const selected_div = section.querySelector('.selected-value');
  const select_div_block = section.querySelector('.collection-dropdown');
  const dropdownItems = section.querySelectorAll('.collection-dropdown li');
  const productGridContainer = section.querySelector("#ProductGridContainer");
  const tagButtons = section.querySelectorAll('.tag-button');

  if (selected_div && select_div_block) {
    selected_div.addEventListener('click', () => {
      const isVisible = select_div_block.style.display === 'block';
      select_div_block.style.display = isVisible ? 'none' : 'block';
    });
  }

  dropdownItems.forEach(item => {
    item.addEventListener('click', () => {
      tagButtons.forEach(btn => btn.classList.remove('active-tag'));
      const dataId = item.getAttribute('data-id')?.trim();
      const dataUrl = item.getAttribute('data-collection-url');

      if (selected_div) {
        selected_div.textContent = item.getAttribute('coll_title');
      }

      select_div_block.style.display = 'none';

      dropdownItems.forEach(li => li.classList.remove('active-tag'));
      item.classList.add('active-tag');

      const allBlocks = document.querySelectorAll('.block-main-inner');
      allBlocks.forEach(block => block.style.display = 'none');

      const selectedBlock = document.getElementById(dataId);
      let vendorTitle = null; // initialize vendorTitle

      if (selectedBlock) {
        selectedBlock.style.display = 'block';

        const imageBtns = selectedBlock.querySelectorAll('button.image-btns');
        const imageImgs = selectedBlock.querySelectorAll('.collection-single-image.img');

        imageBtns.forEach(btn => btn.classList.remove('active-main-image'));
        imageImgs.forEach(img => img.style.display = 'none');

        if (imageBtns.length > 0) {
          imageBtns[0].classList.add('active-main-image');
          const firstImageId = imageBtns[0].getAttribute('data-image');
          vendorTitle = imageBtns[0].getAttribute('data-vendor-title');
          const firstImage = selectedBlock.querySelector('#' + firstImageId);
          if (firstImage) {
            firstImage.style.display = 'block';
            console.log('Vendor Title:', vendorTitle);
          }
        }
      }

      const tagFilterBlocks = document.querySelectorAll('.tag-filters');
      tagFilterBlocks.forEach(block => {
        block.style.display = 'none';
      });

      if (dataId) {
        const matchById = document.getElementById(dataId);
        if (matchById) {
          matchById.style.display = 'block';
        }

        const matchByClass = document.querySelectorAll(`.${dataId}`);
        matchByClass.forEach(el => {
          el.style.display = 'block';
        });
      }

      if (dataUrl && productGridContainer) {
        let fetchUrl = dataUrl;

        if (vendorTitle) {
          if (fetchUrl.includes('?')) {
            fetchUrl += `&filter.p.vendor=${encodeURIComponent(vendorTitle)}`;
          } else {
            fetchUrl += `?filter.p.vendor=${encodeURIComponent(vendorTitle)}`;
          }
        }

        fetch(fetchUrl)
          .then(response => response.ok ? response.text() : Promise.reject(response.statusText))
          .then(html => {
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html;
            const productItems = tempContainer.querySelectorAll('.collection-filter-grid');

            productGridContainer.innerHTML = '';
       productGridContainer.classList.remove('item-3', 'item-4', 'no-product');

        if (productItems.length > 0) {
          const itemsToShow = Array.from(productItems).slice(0, 4);

          itemsToShow.forEach(item => productGridContainer.appendChild(item));

          const count = itemsToShow.length;

          if (count === 3) {
            productGridContainer.classList.add('item-3');
          } else if (count >= 4) {
            productGridContainer.classList.add('item-4');
          }
          // No class added for count === 1 or 2 (as per your logic)
        } else {
          productGridContainer.innerHTML = '<h3 class="no-product-found"><img class="no-product-img" src="https://cdn.shopify.com/s/files/1/0623/9531/8368/files/no-found_1.png?v=1758265369">No products found.</h3>';
          productGridContainer.classList.add('no-product');
        }
          })
          .catch(error => console.error('Error loading collection:', error));
      }
    });
  });

  // Auto-click the first dropdown item on page load
  window.addEventListener('load', () => {
    const firstItem = dropdownItems[0];
    if (firstItem) {
      firstItem.click();
    }
  });


document.querySelectorAll('div#main-banner-tags button.image-btns').forEach(button => {
  button.addEventListener('click', function () {
    const activeDropdown = section.querySelector('.active-tag[data-collection-url]');
    const collectionUrl = activeDropdown?.getAttribute('data-collection-url');
    const vendorTitle = this.getAttribute('data-vendor-title');
    const tab_main_id = this.getAttribute('data-image');

    // Get metafield from active tag-button if any
    const activeTagButton = section.querySelector('.tag-button.active-tag');
    const metafieldUrl = activeTagButton?.getAttribute('data-metafield-url') || '';

    // UI updates for image
    document.querySelectorAll('div#main-banner-tags button.image-btns').forEach(btn => btn.classList.remove('active-main-image'));
    this.classList.add('active-main-image');

    const blockWrap = this.closest('#main-banner-tags').parentElement.querySelector('.block-wrap-explore');
    if (blockWrap) {
      blockWrap.querySelectorAll('.collection-single-image.img').forEach(img => {
        img.style.display = 'none';
      });
      const activeImage = blockWrap.querySelector('#' + tab_main_id);
      if (activeImage) activeImage.style.display = 'block';
    }

    // AJAX Fetch logic
    if (collectionUrl && vendorTitle && productGridContainer) {
      let fetchUrl = collectionUrl;

      // Add metafield if available
      if (metafieldUrl) {
        fetchUrl += `/${metafieldUrl}`;
      }

      // Add vendor filter
      fetchUrl += fetchUrl.includes('?') ? `&filter.p.vendor=${encodeURIComponent(vendorTitle)}` : `?filter.p.vendor=${encodeURIComponent(vendorTitle)}`;

      fetch(fetchUrl)
        .then(response => response.ok ? response.text() : Promise.reject(response.statusText))
        .then(html => {
     const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html;
            const productItems = tempContainer.querySelectorAll('.collection-filter-grid');

            productGridContainer.innerHTML = '';
            productGridContainer.classList.remove('item-3', 'item-4', 'no-product');

          if (productItems.length > 0) {
            const itemsToShow = Array.from(productItems).slice(0, 4);

            itemsToShow.forEach(item => productGridContainer.appendChild(item));

            const count = itemsToShow.length;

            if (count === 3) {
              productGridContainer.classList.add('item-3');
            } else if (count >= 4) {
              productGridContainer.classList.add('item-4');
            }
            // No class added for count === 1 or 2 (as per your logic)
          } else {
          productGridContainer.innerHTML = '<h3 class="no-product-found"><img class="no-product-img" src="https://cdn.shopify.com/s/files/1/0623/9531/8368/files/no-found_1.png?v=1758265369">No products found.</h3>';
            productGridContainer.classList.add('no-product');
          }
        })
        .catch(error => console.error('Error loading collection:', error));
    }
  });
});

  tagButtons.forEach(button => {
    button.addEventListener('click', () => {
      tagButtons.forEach(btn => btn.classList.remove('active-tag'));
      button.classList.add('active-tag');

      const metafieldUrl = button.getAttribute('data-metafield-url');
      const activeDropdown = section.querySelector('.active-tag');
      const collectionUrl = activeDropdown ? activeDropdown.getAttribute('data-collection-url') : null;

      // Get vendor from the active main image button
      const vendorTitle = section.querySelector('.active-main-image')?.getAttribute('data-vendor-title');

      if (activeDropdown && metafieldUrl && collectionUrl && productGridContainer) {
        let newdataUrl = `${collectionUrl}/${metafieldUrl}`;

        if (vendorTitle) {
          newdataUrl += newdataUrl.includes('?')
            ? `&filter.p.vendor=${encodeURIComponent(vendorTitle)}`
            : `?filter.p.vendor=${encodeURIComponent(vendorTitle)}`;
        }

        fetch(newdataUrl)
          .then(response => response.ok ? response.text() : Promise.reject(response.statusText))
          .then(html => {
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html;
            const productItems = tempContainer.querySelectorAll('.collection-filter-grid');

            productGridContainer.innerHTML = '';
           productGridContainer.classList.remove('item-3', 'item-4', 'no-product');

            if (productItems.length > 0) {
              const itemsToShow = Array.from(productItems).slice(0, 4);

              itemsToShow.forEach(item => productGridContainer.appendChild(item));

              const count = itemsToShow.length;

              if (count === 3) {
                productGridContainer.classList.add('item-3');
              } else if (count >= 4) {
                productGridContainer.classList.add('item-4');
              }
              // No class added for count === 1 or 2 (as per your logic)
            } else {
          productGridContainer.innerHTML = '<h3 class="no-product-found"><img class="no-product-img" src="https://cdn.shopify.com/s/files/1/0623/9531/8368/files/no-found_1.png?v=1758265369">No products found.</h3>';
              productGridContainer.classList.add('no-product');
            }
          })
          .catch(error => {
            console.error('Error loading collection:', error);
            productGridContainer.innerHTML = '<p>Error loading products.</p>';
          });
      } else {
        console.warn('No active dropdown item or metafield URL found.');
      }
    });
  });
});